import { configs } from '@constants/configs/configs';
import { SIDENAV_LINKS_TYPES } from '../constants/sideNavLinkTypes';
import { ALL_USER_ROLES } from '@constants/roles/userRoleTypes';
import { ssapModalTypes as MODAL_TYPES } from '@constants/ssap/modals/ssapModalTypes';
const {
    states : {
        IDAHO,
        MINNESOTA,
        NEVADA,
        PENNSYLVANIA,
        NEW_JERSEY,
        NEW_MEXICO,
        OREGON,
        GEORGIA,
        VIRGINIA,
        ILLINOIS,
        GETINSURED
    },
    routes,
    endpoints,
    externalEndpoints,
} = configs;

export const navLinksNames = {
    DELEGATES: 'My Delegates',
    MY_ELIGIBILITY_HISTORY: 'My Eligibility History',
    MY_APPLICATIONS: 'My Applications',
    MY_ELIGIBILITY_HOME: 'My Eligibility Home',
    MY_HOUSEHOLDS: 'My Households',
    MY_TICKETS: 'tickets',
    MY_INBOX_JSP: 'inbox_jsp',
    MY_INBOX: 'inbox',
    PREFERENCES: 'preferences',
    FIND_LOCAL_ASSISTANCE: 'find_local_assistance',
    HISTORICAL_DOCUMENTS: 'historical_documents',
    HISTORICAL_NOTICES: 'historical_notices',
};

/* *
* ToDo - Add description for the keys
* section - specify the
* name - Text for Navigation
* icon -
* type - existing options are 'header', SIDENAV_LINKS_TYPES.LINK, modal
* path -
* */
export const navLinks = {
    [IDAHO]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find__local__assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                },
                {
                    name: 'download__appeals__form',
                    text: 'sidenav_download_appeals_form',
                    icon: 'download',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.ID_LINKS.DOWNLOAD_APPEALS_FORM,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'sidenav_header_accesscode',
            sectionItems: [
                {
                    name: 'access_code',
                    btnname: 'button.submit',
                    icon: '',
                    type: SIDENAV_LINKS_TYPES.INPUT_WITH_SUBMIT_BUTTON,
                    path: '',
                    visibility: true,
                    isDisabled: true
                }
            ]
        }
    ],
    [MINNESOTA]: [
        {
            sectionHeader: null,
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: navLinksNames.MY_ELIGIBILITY_HISTORY,
                    text: 'sidenav_eligibility_history',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => !isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_HOUSEHOLDS,
                    text: 'sidenav_my_households',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: routes.MULTI_HOUSEHOLD_DETAILS,
                    visibility: (multiHouseholdEnabled) => multiHouseholdEnabled
                },
                {
                    name: 'My Enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: (preventConsumerPreferencePageAccess) => !preventConsumerPreferencePageAccess
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ],
            visible: (isStateFullStack) => isStateFullStack,
        }
    ],
    [NEVADA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                },
                {
                    name: 'user_guides',
                    text: 'indportal.sidenav.dashboard.userGuides',
                    icon: 'folder-open',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: externalEndpoints.NV_LINKS.USER_GUIDES,
                    visibility: true,
                    blank: true
                }
            ]
        }
    ],
    [PENNSYLVANIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [NEW_MEXICO]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.HISTORICAL_DOCUMENTS,
                    text: 'indportal.sidenav.dashboard.historicalDocuments',
                    icon: 'inbox',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.HISTORICAL_DOCUMENTS,
                    visibility: (showHistoricalData) => showHistoricalData
                },
                {
                    name: navLinksNames.HISTORICAL_NOTICES,
                    text: 'indportal.sidenav.dashboard.historicalNotices',
                    icon: 'file-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.HISTORICAL_NOTICES,
                    visibility: (showHistoricalData) => showHistoricalData
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [GETINSURED]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [NEW_JERSEY]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true
                }
            ]
        }
    ],
    [GEORGIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: 'preferences',
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: (preventConsumerPreferencePageAccess) => !preventConsumerPreferencePageAccess
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    path: '#',
                    visibility: true
                }
            ]
        }
    ],
    [VIRGINIA]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    path: '#',
                    visibility: true
                }
            ]
        }
    ],
    [ILLINOIS]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true,
                    isLinkDisabled: (isFindAssistanceLinkDisabled) => isFindAssistanceLinkDisabled
                }
            ]
        }
    ],
    [OREGON]: [
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerMyStuff',
            sectionItems: [
                {
                    name: 'dashboard',
                    text: 'indportal.sidenav.dashboard.Dashboard',
                    icon: 'tachometer-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.INDPORTAL,
                    visibility: true
                },
                {
                    name: navLinksNames.MY_APPLICATIONS,
                    text: 'indportal.sidenav.dashboard.applications',
                    icon: 'info-circle',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.APPLICATIONS,
                    visibility: (isStateFullStack) => isStateFullStack
                },
                {
                    name: 'eligibility_results',
                    text: 'indportal.sidenav.dashboard.eligibilityResults',
                    icon: 'clipboard-check',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.ELIGIBILITY_RESULTS,
                    visibility: true
                },
                {
                    name: 'enrollments',
                    text: 'indportal.sidenav.dashboard.enrollments',
                    icon: 'check-square',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.MY_ENROLLMENT_HISTORY,
                    visibility: true
                },
                {
                    name: navLinksNames.DELEGATES,
                    text: 'indportal.sidenav.dashboard.delegates',
                    icon: 'users',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.DELEGATION_CONSUMER,
                    visibility: (delegationEnabled, isIndividualUser) => delegationEnabled && isIndividualUser === ALL_USER_ROLES.INDIVIDUAL
                },
                {
                    name: navLinksNames.MY_INBOX_JSP,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.LINK,
                    path: endpoints.INBOX_HOME,
                    visibility: (telexEnabled) => !telexEnabled
                },
                {
                    name: navLinksNames.MY_INBOX,
                    text: 'indportal.sidenav.dashboard.inbox',
                    icon: 'envelope',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.NEW_INBOX_HOME,
                    visibility: (telexEnabled) => telexEnabled
                },
                {
                    name: navLinksNames.MY_TICKETS,
                    text: 'indportal.sidenav.dashboard.tickets',
                    icon: 'ticket-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.TICKET_CONSUMER,
                    visibility: (ticketEnabled) => ticketEnabled
                },
                {
                    name: navLinksNames.PREFERENCES,
                    text: 'indportal.sidenav.dashboard.preferences',
                    icon: 'phone-square-alt',
                    type: SIDENAV_LINKS_TYPES.REACT_ROUTER_LINK,
                    path: routes.COMMUNICATION_PREFERENCES,
                    visibility: true
                }
            ]
        },
        {
            sectionHeader: 'indportal.sidenav.dashboard.headerQuickLinks',
            sectionItems: [
                {
                    name: 'find_local_assistance',
                    text: 'indportal.sidenav.dashboard.findLocalAssistance',
                    icon: 'search',
                    type: SIDENAV_LINKS_TYPES.MODAL,
                    modalName: MODAL_TYPES.LOCATE_ASSISTANCE_MODAL,
                    visibility: true,
                    isLinkDisabled: (isFindAssistanceLinkDisabled) => isFindAssistanceLinkDisabled
                }
            ]
        }
    ],
};